// mutations
import { showInfoDialog } from '@/api'
const SCHOOLROUTES_MONITORS_ALL = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MONITORS_FORM = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MONITORS_SHOW = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MONITORS_CREATE = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    showInfoDialog("Mensaje informativo",schoolRoutesMonitors.message,"Aceptar")
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MONITORS_UPDATE = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    showInfoDialog("Mensaje informativo",schoolRoutesMonitors.message,"Aceptar")
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

const SCHOOLROUTES_MONITORS_DELETE = (state, schoolRoutesMonitors) => {
  if (schoolRoutesMonitors.code === 1) {
    state.schoolRoutesMonitors = schoolRoutesMonitors.data
    state.status = 'success'
  } else {
    alert(schoolRoutesMonitors.message)
    state.status = 'error'
  }
}

export default {
  SCHOOLROUTES_MONITORS_ALL,
  SCHOOLROUTES_MONITORS_FORM,
  SCHOOLROUTES_MONITORS_SHOW,
  SCHOOLROUTES_MONITORS_CREATE,
  SCHOOLROUTES_MONITORS_UPDATE,
  SCHOOLROUTES_MONITORS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/monitors/mutations.js